import React, {useState} from 'react';
import cl from './SubscriptionCancellationsPage.module.css';
import {Divider} from "@mui/material";
import SubscriptionCancellationsPageMenuItem from "./SubscriptionCancellationsPageMenuItem";
import AlertSnackbar from "../../components/AlertSnackbar/AlertSnackbar";
import LoadingOverlay from "../../components/LoadingOverlay/LoadingOverlay";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import SubscriptionCancellationsSummarySubPage from "./SubscriptionCancellationsSummarySubPage";
import SubscriptionCancellationsBrowseSubPage from "./SubscriptionCancellationsBrowseSubPage";

const subPages = [
    {title: "Сводка", SubPageComponent: SubscriptionCancellationsSummarySubPage},
    {title: "Обзор", SubPageComponent: SubscriptionCancellationsBrowseSubPage},
];

const SubscriptionCancellationsPage = ({isAddSubMode}) => {

    const [currentSubPage, setCurrentSubPage] = useState(subPages[0]);

    const CurrentSubPageComponent = currentSubPage.SubPageComponent;

    // TODO: можно сделать глобальными? обрабатывать в корневом компоненте?
    const [loadingOverlayData, setLoadingOverlayData] = useState(null); // { title }
    const [snackbarData, setSnackbarData] = useState(null); // { severity, title, message }
    const [confirmDialogData, setConfirmDialogData] = useState(null); // { message, confirmLabel, cancelLabel, onAnswer }

    const handleErrorSnackbarClose = (event, reason) => {
        setSnackbarData(null);
    };

    return (
        <div className={cl.main}>
            <div className={cl.menu}>
                {subPages.map(item => (
                    <SubscriptionCancellationsPageMenuItem
                        key={item.title}
                        title={item.title}
                        selected={item === currentSubPage}
                        onClick={() => setCurrentSubPage(item)}
                    />
                ))}
            </div>
            <Divider sx={{margin: "0 10px"}}/>
            <div className={cl.workArea}>
                <CurrentSubPageComponent isAddSubMode={isAddSubMode}/>
            </div>
            {snackbarData && <AlertSnackbar
                open={true}
                severity={snackbarData.severity}
                title={snackbarData.title}
                message={<div style={{whiteSpace:"pre-line"}}>{snackbarData.message}</div>}
                onClose={handleErrorSnackbarClose}
            />}
            {loadingOverlayData && <LoadingOverlay
                open={true}
                title={loadingOverlayData.title}
            />}
            {confirmDialogData && <ConfirmDialog
                open={true}
                message={confirmDialogData.message}
                confirmLabel={confirmDialogData.confirmLabel}
                cancelLabel={confirmDialogData.cancelLabel}
                onAnswer={confirmDialogData.onAnswer}
            />}
        </div>
    );
};

export default SubscriptionCancellationsPage;